import { message } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import apiCall from "../../../components/Api";
import StatusComponent from "../../../components/Common/StatusComponent";
import { navBarData, PincodebreadcrumbsList } from "../Const";
import MasterListLayout from "../MasterListLayout";
import { usePaginatedList } from "../MedicineList/utils";

const PincodeList = () => {
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState({ id: "", status: false });
  const [loader, setLoader] = useState(true);

  const {
    records,
    count,
    pages,
    skip,
    limit,
    setLimit,
    handlePageChange,
    handleSortClick,
    debouncedSearch,
    list_api_call,
  } = usePaginatedList({ endpoint: "pincode/list" });

  const handleAdd = () => {
    navigate("/healthsy-services/order-medicines/masters/pincode-list-form");
  };

  const handleEdit = (id) => {
    navigate(
      `/healthsy-services/order-medicines/masters/pincode-list-form-edit/${id}`
    );
  };

  const handleClose = () => {
    setDeleteModal({ id: "", status: false });
  };

  const handleDelete = async (id) => {
    try {
      await apiCall(`pincode/delete/${id}`, "DELETE", null, null);
      list_api_call();
      setDeleteModal({ id: "", status: false });
      message.success("Item deleted successfully");
    } catch (error) {
      setDeleteModal({ id: "", status: false });
      message.error("Failed to delete item");
    }
  };

  const handleActive = async (id, status) => {
    try {
      await apiCall(
        `pincode/update/${id}`,
        "PATCH",
        { delivarable: !status },
        null
      );
      list_api_call();
      message.success("Status updated successfully");
    } catch (error) {
      message.error("Failed to update status");
    }
  };

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) => Number(skip || 0) + (index + 1),
      key: "serial",
      width: 80,
    },
    {
      title: "Status & Actions",
      render: (text, record) => (
        <StatusComponent
          text={text}
          record={record}
          handleEdit={handleEdit}
          setDeleteModal={setDeleteModal}
          handleActive={handleActive}
          title={"pincode"}
          delivary_status={
            record.delivarable ? "Delivarable" : "Not Delivarable"
          }
        />
      ),
      key: "actions",
      width: 170,
    },
    {
      title: "Pincode List",
      dataIndex: "pincode_list",
      key: "pincode_list",
      width: 200,
      render: (text, record) => (
        <span className="">{Number(record.pincode)}</span>
      ),
    },
  ];

  useEffect(() => {
    records.length > 0 && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <MasterListLayout
      title="Pincode"
      breadcrumbsList={PincodebreadcrumbsList("list")}
      onAdd={handleAdd}
      uploadApi="pincode/create-bulk"
      columns={columns}
      records={records}
      count={count}
      pages={pages}
      skip={skip}
      limit={limit}
      handlePageChange={handlePageChange}
      handleDelete={handleDelete}
      deleteModal={deleteModal}
      setDeleteModal={setDeleteModal}
      handleClose={handleClose}
      setLimit={setLimit}
      handleSortClick={handleSortClick}
      onChangeSearch={debouncedSearch}
      navBarData={navBarData}
      loader={loader}
    />
  );
};

export default PincodeList;
